export default {
  LeftMenu: {
    Control: 'Control',
    CollapseText: 'Thu gọn',
    Dashboard: 'Tổng quan',
    Cash: 'Tiền mặt tại quỹ',
    Deposits: 'Tiền gửi ngân hàng',
    Asset: 'Tài sản-Tang vật ',
    Report: 'Báo cáo',
    Dictionary: 'Danh mục',
  },
  Nav: {
    PostedDate: 'Ngày hạch toán:',
    Search: 'Tìm chứng từ',
  },
};
